export default __webpack_public_path__ + "static/media/scott_noh.2eb61215.gif";